import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/gorillaservices.webp';
import screenshot_target from '../../../images/letterfunnel/joachimbeckmann.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Joachim Beckmann"
      firstname="Joachim"
      companyname="Gorilla Services"
      competition="Syrca en Fluix"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/joachimbeckmann.js